import React from 'react';
import './Drinks.scss';

function Drinks() {
    return (
        <div className="drinks">
            <div className="drinks__bg"></div>
            <div className="drinks__card">
                        <div className="drinks__info">
                            Dr. Pepper
                        </div>
                        <div className="drinks__price">$1.00</div>
                </div>
                <div className="drinks__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="drinks__info">
                            Orange
                        </div>
                        <div className="drinks__price">$1.00</div>
                </div>
                <div className="drinks__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="drinks__info">
                            Jamaica
                        </div>
                        <div className="drinks__price">$1.50</div>
                </div>
                <div className="drinks__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="drinks__info">
                            Tamarindo
                        </div>
                        <div className="drinks__price">$1.50</div>
                </div>
                <div className="drinks__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="drinks__info">
                            Pepsi
                        </div>
                        <div className="drinks__price">$1.00</div>
                </div>
                <div className="drinks__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="drinks__info">
                            Sierra Mist
                        </div>
                        <div className="drinks__price">$1.00</div>
                </div>
                <div className="drinks__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="drinks__info">
                            Diet Pepsi
                        </div>
                        <div className="drinks__price">$1.00</div>
                </div>
                <div className="drinks__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="drinks__info">
                            Horchata
                        </div>
                        <div className="drinks__price">$1.50</div>
                </div>
        </div>
    )
}

export default Drinks
